<template>
	<div>
	<base-form v-if="!loading" class="w-full" ref="roundForm" :fields-in-row="3" :form-data="roundForm" :edit-record="golfRound" @submitted="save"></base-form>
	</div>
</template>
<script>
/** @format */
import courses from './../../modules/courses'

export default {
	name: 'RoundForm',
	props: {
		golfRound: {
			type: Object,
			required: false
		}
	},
	methods: {
		save(payload) {
			this.$store.dispatch('notification/add', {type: 'info', message: 'Saving round data.'});
			if (this.golfRound) {
				this.$store
					.dispatch(`rounds/edit`, { roundUuid: this.golfRound.uuid, payload })
					.then((response) => {
						this.$emit('round-saved', response.data.data)
						this.$store.dispatch('notification/add', {type: 'success', message: 'Round saved successfully.'});
					})
					.finally(() => {
						this.$refs.roundForm.cancelSubmit();
					});
			} else {
				this.$store
					.dispatch('rounds/add', { payload })
					.then((response) => {
						this.$emit('round-saved', response.data.data)
						this.$refs.roundForm.resetFieldValues();
						this.$store.dispatch('notification/add', {type: 'success', message: 'Round saved successfully.'});
					})
					.finally(() => {
						this.$refs.roundForm.cancelSubmit();
					});
			}
		},
		loadTees(courseUuid) {
			if (this.teeOptions[courseUuid]) {
				this.roundForm[1].props.options = this.teeOptions[courseUuid].map(o => {
					return {
						id: o.uuid,
						name: o.tee
					};
				})
				if (this.teeOptions[courseUuid].length > 0) {
					this.roundForm[1].value = this.teeOptions[courseUuid][0].uuid;
				}
			}
		}
	},
	mounted() {
		this.loading = true;
		courses.getAll().then(courseList => {
			courseList.forEach(course => {
				this.roundForm[0].props.options.push({
					id: course.uuid,
					name: course.name
				});
				this.teeOptions[course.uuid] = course.tees;
			});
			if (this.golfRound) {
				this.loadTees(this.golfRound.course.uuid);
			}
			this.$nextTick(() => {
				this.loading = false;
				this.$emit('courses-loaded');
			})
		})
	},
	data() {
		const $this = this;
		return {
			loading: true,
			teeOptions: {},
			roundForm: [
				{
					name: 'course_id',
					label: 'Course',
					component: 'base-select',
					props: {
						options: [],
						label: 'name',
						trackBy: 'id',
						uneditable: true,
						onChange(e) {
							$this.loadTees(e);
						}
					}

				},
				{
					name: 'tee_id',
					label: 'Tee',
					component: 'base-select',
					props: {
						options: [],
						label: 'name',
						trackBy: 'id',
						uneditable: true,
					}
				},
				{
					name: 'title',
					component: 'base-input'
				},
				{
					name: 'handicap_before',
					component: 'base-input'
				},
				{
					name: 'handicap_after',
					component: 'base-input'
				},
				{
					name: 'date_played',
					component: 'base-date'
				},
				{
					name: 'competition',
					component: 'base-boolean' // true/false boolean
				}
			],
			loading: false,
		}
	}
};
</script>
